import Vue from 'vue';

import Vuetify from 'vuetify/lib';
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader

import en from 'vuetify/es5/locale/en'
import ja from 'vuetify/es5/locale/ja'
import zhHans  from 'vuetify/es5/locale/zh-Hans'

var lang = (window.navigator.languages && window.navigator.languages[0]) ||
            window.navigator.language ||
            window.navigator.userLanguage ||
            window.navigator.browserLanguage;

Vue.use(Vuetify);

let primary_color = ""
const domain = location.hostname.split(".");
if(domain[0].endsWith("t-3mt") || domain[0].startsWith("localhost")){
  primary_color = "#005EAC";
}else{
  primary_color = "#00B8EE";
}

export default new Vuetify({
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
  lang: {
    locales: { en, ja, zhHans  },
    current: lang
  },
  theme: {
    themes: {
      light: {
        primary: primary_color,
      },
    },
    options: { customProperties: true }
  },
})
